import ExposedEmployeeList from "./"
import PropTypes from "prop-types"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import moment from "moment"
import { EXPOSED_EMPLOYEE_LIST } from "../../apollo/queries"

const ExposedEmployeeListEnhanced = compose(
  withProps((props) => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
      startAt: props.caseStartAt,
      endAt: props.caseEndAt,
    }
  }),
  graphql(EXPOSED_EMPLOYEE_LIST, {
    options: ({ facilityId, caseId, startAt, endAt }) => ({
      variables: { facilityId, caseId, startAt, endAt },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const kase = facility.contactTracingCases[0]

      const employeePositiveCase =
        kase.subjects.filter((subject) => subject.entity.__typename === "User")
          .length > 0

      let entities = []

      if (employeePositiveCase) {
        entities =
          kase.subjects[0].entity.contactTracingVisits.edges.length >= 1
            ? kase.subjects[0].entity.contactTracingVisits.edges.map(
                (edge) => ({
                  id: edge.node.location.id,
                  startAt: edge.node.entryAt,
                  endAt: edge.node.exitAt,
                })
              )
            : []
      } else {
        entities = kase.subjects.map((subject) => ({
          id: subject.entity.id,
          startAt: subject.startAt,
          endAt: subject.endAt,
        }))
      }

      return {
        startAt: moment
          .min(
            kase.subjects.map((subject) => moment.parseZone(subject.startAt))
          )
          .format(),
        endAt: moment
          .max(kase.subjects.map((subject) => moment.parseZone(subject.endAt)))
          .format(),
        entities: entities,
        rows: kase.exposedUsers.map((exposedUser) => ({
          id: exposedUser.exposed.id,
          name: exposedUser.exposed.name,
          employeeId: exposedUser.exposed.employeeId,
          role: exposedUser.exposed.healthcareRole,
          firstContact: moment.parseZone(exposedUser.firstContact),
          lastContact: moment.parseZone(exposedUser.lastContact),
          exposureDuration: moment.duration(
            exposedUser.exposureDuration,
            "seconds"
          ),
          department: exposedUser.exposed.department.name,
          compliance:
            exposedUser.exposed.compliance.timeslices.full.aggregates.overall
              .compliancePercentage,
        })),
      }
    },
  })
)(ExposedEmployeeList)

ExposedEmployeeListEnhanced.propTypes = {
  caseStartAt: PropTypes.string.isRequired,
  caseEndAt: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["employeePositive", "patientPositive"]).isRequired,
}

export default ExposedEmployeeListEnhanced
